import type { DependencyList } from 'react';
import { useCallback } from 'react';
import type { DebouncedFunc } from 'lodash-es';
import useDebouncedFunction from './useDebouncedFunction';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useDebouncedMemoizedFunction<T extends (...args: any[]) => any>(
	callback: T,
	deps: DependencyList,
	waitMs: number,
): DebouncedFunc<T> {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const memoized = useCallback(callback, deps);

	const debounced = useDebouncedFunction(memoized, waitMs);

	return debounced;
}
